import { I18n } from "aws-amplify";
import { parseDate, toolToFixed } from "../ScrbTools";

export const printView = (installation, data, structure) => {
    const genreInst = installation.genreInstallationId;
    const installationColor = data.installationColors[installation.genreInstallationId];

    return (
        <div className="">
            <div className="flex flex-row justify-content-between align-items-center pt-3">
                <img src={'../../../assets/layout/images/scrb_logo.svg'} alt="logo" style={{ width: '150px', height: '100px' }} />
                <i className={installationColor.icon} style={{ fontSize: '40px', color: installationColor.color }}></i>
                <img src={'../../../assets/layout/images/cdm_logo.svg'} alt="logo" style={{ width: '150px', height: '100px' }} />
            </div>
            <div className="flex flex-row justify-content-start pt-3 pb-3">
                <div className="flex flex-column justify-content-start w-8">
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="label mr-2 font-bold">{I18n.get("genreInstallation")}: </span>
                        <span className="value font-bold">{(data.genreInstList.find(genre => genre.id === installation.genreInstallationId)?.label)}</span>
                    </div>
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="label mr-2 font-bold">{I18n.get("reference")}: </span>
                        <span className="value font-bold">{installation.referenceExterne}</span>
                    </div>
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="label mr-2 font-bold">{I18n.get("installateur")}: </span>
                        <span className="value font-bold">{structure.name}</span>
                    </div>
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="label mr-2 font-bold">{I18n.get("genreReception")}: </span>
                        <span className="value font-bold">{I18n.get(data.genreReceptionsList.find(genre => genre.id === installation.genreReception)?.label)}</span>
                    </div>
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="label mr-2 font-bold">{I18n.get("dateDemande")}: </span>
                        <span className="value font-bold">{parseDate(installation.dateDemande)}</span>
                    </div>
                    <div className="flex flex-row justify-content-start align-items-center">
                        <span className="label mr-2 font-bold">{I18n.get("numCommandeClient")}: </span>
                        <span className="value font-bold">{installation.numCommandeClient}</span>
                    </div>
                </div>
                <div className=" pt-6 w-6">
                    <span className="label text-2xl font-bold">{I18n.get("Demande de réception")}</span>
                </div>
            </div>
            <hr />
            {/* Emplacement */}
            <div className="flex flex-row justify-content-start text-xs pb-3">
                <div className="flex flex-column w-6">
                    <h5>{I18n.get("utilisateur")}</h5>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("nom")}:</span>
                        <span className="value">{installation.nom}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("mail")}:</span>
                        <span className="value">{installation.mail}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("tel")}:</span>
                        <span className="value">{installation.tel}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("address")}:</span>
                        <span className="value">{installation.address.street} {installation.address.number}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("localite")}:</span>
                        <span className="value">{installation.address.codePostal} {installation.address.localite}</span>
                    </div>
                </div>
                <div className="flex flex-column w-6">
                    <h5>{I18n.get("proprietaire")}</h5>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("nom")}:</span>
                        <span className="value">{installation.nomOwner}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("mail")}:</span>
                        <span className="value">{installation.mailOwner}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("tel")}:</span>
                        <span className="value">{installation.telOwner}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("address")}:</span>
                        <span className="value">{installation.addressOwner.street} {installation.addressOwner.number}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("localite")}:</span>
                        <span className="value">{installation.addressOwner.codePostal} {installation.addressOwner.localite}</span>
                    </div>
                </div>
            </div>
            <hr />
            {/*Specifications*/}
            <div className="flex flex-row justify-content-start pb-3">
                <div className="flex flex-column w-6 text-xs">
                    <h5>{I18n.get("batiment")}</h5>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("typeBatiment")}:</span>
                        <span className="value">{I18n.get(data.typeBatimentList[installation.typeBatiment].label)}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("typeInstallation")}:</span>
                        <span className="value">{I18n.get(data.typeInstallationList[installation.typeInstallation].label)}</span>
                    </div>
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("specifications")}:</span>
                        <span className="value">{installation.specification}</span>
                    </div>
                    {genreInst < 5 && (<>
                        <div className="w-full flex flex-row">
                            <span className="label w-5">{I18n.get("etage")}:</span>
                            <span className="value">{installation.etage}</span>
                        </div>
                        <div className="w-full flex flex-row">
                            <span className="label w-5">{I18n.get("nbEtages")}:</span>
                            <span className="value">{installation.nbEtages}</span>
                        </div>
                    </>)}
                    {genreInst === 5 && (<>
                        <div className="w-full flex flex-row">
                            <span className="label w-5">{I18n.get("anneeRenovBatiment")}:</span>
                            <span className="value">{installation.anneeRenovBatiment.getFullYear()}</span>
                        </div>
                        <div className="w-full flex flex-row">
                            <span className="label w-5">{I18n.get("surfaceRefEnergitique")}:</span>
                            <span className="value">{installation.surfaceRefEnergitique}</span>
                        </div>
                    </>)}
                    <div className="w-full flex flex-row">
                        <span className="label w-5">{I18n.get("localEmplacement")}:</span>
                        <span className="value">{installation.localEmplacement}</span>
                    </div>
                </div>
                {genreInst === 3 && appareilClim(installation, data)}
                {[2, 1, 4].includes(genreInst) && appareilGaz(installation, data)}
                {genreInst === 5 && appareilPompe(installation, data)}
            </div>
            <hr />
            {/*Chaudiere*/}
            {genreInst === 3 && chaudiereClim(installation)}
            {[2, 1, 4].includes(genreInst) && (<div className="flex flex-row justify-content-start">
                {chaudiereGaz(installation)}
                {genreInst !== 4 && bruleurGaz(installation)}
            </div>
            )}
            {genreInst === 5 && chaudierePompe(installation, data)}
            {legalText(genreInst)}
        </div>
    )
}

const appareilPompe = (installation, data) => {
    return (
        <div className="flex flex-column w-6  text-xs">
            <h5>{I18n.get("appareil")}</h5>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("typePompe")}:</span>
                <span className="value">{I18n.get(data.typeChaudiereList[installation.chaudiere.typeChaudiere].label)}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("typeFluide")}:</span>
                <span className="value">{installation.chaudiere.typeFluide}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("qteRemplissageRefrigerant")}:</span>
                <span className="value">{installation.chaudiere.qteRemplissageRefrigerant}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("modeFonctionnementPompe")}:</span>
                <span className="value">{I18n.get(data.modeFonctionnementPompeList[installation.chaudiere.modeFonctionnementPompe - 1].label)}</span>
            </div>
            {installation.chaudiere.modeFonctionnementPompe === 1 && (
                <div className="w-full flex flex-row">
                    <span className="label w-5">{I18n.get("puissanceResistance")}:</span>
                    <span className="value">{installation.chaudiere.puissanceResistance}</span>
                </div>
            )}
            {installation.chaudiere.modeFonctionnementPompe === 2 && (
                <div className="w-full flex flex-row">
                    <span className="label w-5">{I18n.get("puissanceDeuxiemeGenerateur")}:</span>
                    <span className="value">{installation.chaudiere.puissanceDeuxiemeGenerateur}</span>
                </div>
            )}
        </div>
    )
}

const chaudierePompe = (installation, data) => {
    return (
        <div className="flex flex-column w-12  text-xs">
            <h5>{I18n.get("scrb_pompe_chaleur")}</h5>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("marqueChaudiere")}:</span>
                <span className="value">{installation.chaudiere.marqueChaudiere}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("modelChaudiere")}:</span>
                <span className="value">{installation.chaudiere.modelChaudiere}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("anneeConstructChaudiere")}:</span>
                <span className="value">{installation.chaudiere.anneeConstructChaudiere.getFullYear()}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("anneeEntreeChaudiere")}:</span>
                <span className="value">{installation.chaudiere.anneeEntreeChaudiere.getFullYear()}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("chargeChauffageBatiment")}:</span>
                <span className="value">{installation.chaudiere.chargeChauffageBatiment}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("puissanceNecessaireEauChaude")}:</span>
                <span className="value">{installation.chaudiere.puissanceNecessaireEauChaude}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-6">{I18n.get("puissanceSelonNorme")}:</span>
                <span className="value">{installation.chaudiere.puissanceSelonNorme}</span>
            </div>
        </div>
    )
}

const appareilClim = (installation, data) => {
    return (
        <div className="flex flex-column w-6  text-xs">
            <h5>{I18n.get("appareil")}</h5>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("typeCondenseur")}:</span>
                <span className="value">{I18n.get(data.typeCondenseurList[installation.chaudiere.typeCondenseur].label)}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("typeEvaporateur")}:</span>
                <span className="value">{I18n.get(data.typeEvaporateurList[installation.chaudiere.typeEvaporateur].label)}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("utilisation")}:</span>
                <span className="value">{I18n.get(data.utilisationList[installation.utilisation].label)}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("typeFluide")}:</span>
                <span className="value">{installation.chaudiere.typeFluide}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("fluideCaloporteur")}:</span>
                <span className="value">{installation.chaudiere.fluideCaloporteur}</span>
            </div>
        </div>
    )
}

const chaudiereClim = (installation) => {
    return <div className="flex flex-row justify-content-start">
        <div className="flex flex-column w-6 text-xs">
            <h5>{I18n.get("scrb_clim")}</h5>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("marqueChaudiere")}:</span>
                <span className="value">{installation.chaudiere.marqueChaudiere}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("modelChaudiere")}:</span>
                <span className="value">{installation.chaudiere.modelChaudiere}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("anneeConstructChaudiere")}:</span>
                <span className="value">{installation.chaudiere.anneeConstructChaudiere.getFullYear()}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("anneeEntreeChaudiere")}:</span>
                <span className="value">{installation.chaudiere.anneeEntreeChaudiere.getFullYear()}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("chargeNominale")}:</span>
                <span className="value">{installation.chaudiere.chargeNominale}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("puissanceFrigo")}:</span>
                <span className="value">{installation.chaudiere.puissanceFrigo}</span>
            </div>
            <div className="w-full flex flex-row">
                <span className="label w-5">{I18n.get("puissanceElec")}:</span>
                <span className="value">{installation.chaudiere.puissanceElec}</span>
            </div>
        </div>
    </div>
}

const appareilGaz = (installation, data) => {
    return <div className="flex flex-column w-6  text-xs">
        <h5>{I18n.get("appareil")}</h5>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("combustible")}:</span>
            <span className="value">{I18n.get(data.typeCombustibleList[installation.combustible].label)}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("typeChaudiere")}:</span>
            <span className="value">{I18n.get(data.typeChaudiereList[installation.chaudiere.typeChaudiere].label)}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("typeBruleur")}:</span>
            <span className="value">{I18n.get(data.typeBruleurList[installation.bruleur.typeBruleur].label)}</span>
        </div>
        {installation.typeAppareil && (<div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("typeAppareil")}:</span>
            <span className="value">{data.typeAppareilList[installation.typeAppareil]}</span>
        </div>
        )}
    </div>
}

const chaudiereGaz = (installation) => {
    return <div className="flex flex-column w-6  text-xs">
        <h5>{I18n.get("chaudiere")}</h5>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("marqueChaudiere")}:</span>
            <span className="value">{installation.chaudiere.marqueChaudiere}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("modelChaudiere")}:</span>
            <span className="value">{installation.chaudiere.modelChaudiere}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("anneeConstructChaudiere")}:</span>
            <span className="value">{installation.chaudiere.anneeConstructChaudiere.getFullYear()}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("anneeEntreeChaudiere")}:</span>
            <span className="value">{installation.chaudiere.anneeEntreeChaudiere.getFullYear()}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("aggreationCE")}:</span>
            <span className="value">{installation.chaudiere.aggreationCE}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("puissanceChaudiere")}:</span>
            <span className="value">{toolToFixed(installation.chaudiere.puissanceMinChaudiere)} - {toolToFixed(installation.chaudiere.puissanceMaxChaudiere)} kW</span>
        </div>
    </div>
}

const bruleurGaz = (installation) => {
    return <div className="flex flex-column w-6  text-xs">
        <h5>{I18n.get("bruleur")}</h5>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("marqueBruleur")}:</span>
            <span className="value">{installation.bruleur.marqueBruleur}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("modelBruleur")}:</span>
            <span className="value">{installation.bruleur.modelBruleur}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("anneeConstructBruleur")}:</span>
            <span className="value">{installation.bruleur.anneeConstructBruleur.getFullYear()}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("anneeEntreeBruleur")}:</span>
            <span className="value">{installation.bruleur.anneeEntreeBruleur.getFullYear()}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("aggreationCE")}:</span>
            <span className="value">{installation.bruleur.aggreationCE}</span>
        </div>
        <div className="w-full flex flex-row">
            <span className="label w-5">{I18n.get("puissanceBruleur")}:</span>
            <span className="value">{toolToFixed(installation.bruleur.puissanceMinBruleur)} - {toolToFixed(installation.bruleur.puissanceMaxBruleur)} kW</span>
        </div>
    </div>
}

const legalText = (genreInst) => {
    const solideMazout = "Règlement grand-ducal du 5 juin 2019 modifiant le règlement grand-ducal modifié du 7 octobre 2014 relatif aux installation de combustion alimentées en combustible solide ou liquide d’une puissance nominale utile supérieure à 7 kW et inférieure à 1 MW."
    const gaz = "Règlement grand-ducal du 27 février 2010 concernant les installations à gaz."
    const clim = "Règlement grand-ducal du 22 juin 2016 relatif: \n a) aux contrôles d'équipements de réfrigération, de climatisation et de pompes à chaleur fonctionnant aux fluides réfrigérants du type HFC, HCFC ou CFC;" +
        "\n b) à l'inspection des systèmes de climatisation."
    const pompe = "Règlement grand-ducal du 17 août 2026 relatif aux modalités d'exploitation des pompes à chaleur."
    let text;
    switch (genreInst) {
        case 2:
            text = gaz;
            break;
        case 3:
            text = clim;
            break;
        case 5:
            text = pompe;
            break;
        default:
            text = solideMazout;
    }
    return <div className="flex flex-row justify-content-center print-footer pt-3">
        {/*<img src={'../../../assets/layout/images/redlion.svg'} alt="logo" style={{ width: '100px', height: '50px' }} />*/}
        <span className="pl-3" style={{ whiteSpace: 'pre-line' }}>{text}</span>
    </div>
}
